/* CUSTOM — flechas, selector de talla y botón de compra en la imagen ampliada.
   Se carga con defer y no hace nada hasta que se abre la primera foto, para no afectar a la carga de la página. */
(function () {
  function iniciar(modal) {
    var sid = modal.id.replace('ProductModal-', '');
    var content = modal.querySelector('.product-media-modal__content');
    var btnPrev = modal.querySelector('[data-cr-modal-prev]');
    var btnNext = modal.querySelector('[data-cr-modal-next]');
    var btnCompra = modal.querySelector('[data-cr-modal-compra]');
    var cerrar = modal.querySelector('.product-media-modal__toggle');

    function limpiar(t) { return (t || '').replace(/\s+/g, ' ').trim(); }
    function main() { return document.getElementById('ProductSubmitButton-' + sid) || document.querySelector('.product-form__submit'); }
    function items() {
      return [].slice.call(content.children).filter(function (el) {
        return el.hasAttribute('data-media-id') && !el.classList.contains('product__media-item--variant');
      });
    }
    function actual() {
      var l = items();
      for (var i = 0; i < l.length; i++) if (l[i].classList.contains('active')) return i;
      return 0;
    }
    var ultimaId = null;
    function recordar() {
      var l = items();
      for (var i = 0; i < l.length; i++) if (l[i].classList.contains('active')) { ultimaId = l[i].getAttribute('data-media-id'); return; }
    }
    // El tema reemplaza las fotos de la ampliación al cambiar de talla/color y las deja sin "active": la restauramos
    function restaurar() {
      var l = items();
      if (!l.length) return;
      for (var i = 0; i < l.length; i++) if (l[i].classList.contains('active')) { recordar(); return; }
      var objetivo = l.filter(function (el) { return el.getAttribute('data-media-id') === ultimaId; })[0] || l[0];
      objetivo.classList.add('active');
      recordar();
    }
    new MutationObserver(function () { restaurar(); sync(); }).observe(content, { childList: true });
    function ir(delta) {
      var l = items();
      if (l.length < 2) return;
      var i = actual();
      var n = (i + delta + l.length) % l.length;
      l[i].classList.remove('active');
      l[n].classList.add('active');
      recordar();
      content.scrollTop = 0;
    }
    var cajaTalla = modal.querySelector('[data-cr-modal-talla-caja]');
    var lista = modal.querySelector('[data-cr-modal-talla-lista]');
    var btnTalla = modal.querySelector('[data-cr-modal-talla]');
    var txtTalla = modal.querySelector('[data-cr-modal-talla-texto]');

    function fieldsetTalla() {
      var fs = [].slice.call(document.querySelectorAll('variant-selects fieldset, variant-radios fieldset'));
      for (var i = 0; i < fs.length; i++) {
        var lg = fs[i].querySelector('legend');
        if (lg && /talla|size/i.test(lg.textContent)) return fs[i];
      }
      return null;
    }
    function opcionesTalla() {
      var fs = fieldsetTalla();
      if (!fs) return [];
      return [].slice.call(fs.querySelectorAll('input[type="radio"]'));
    }
    function tallaElegida() {
      var o = opcionesTalla().filter(function (i) { return i.checked; })[0];
      return o ? o.value : '';
    }
    function cerrarLista() {
      lista.hidden = true;
      btnTalla.setAttribute('aria-expanded', 'false');
    }
    function pintarLista() {
      var ops = opcionesTalla();
      lista.innerHTML = '';
      ops.forEach(function (op) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.className = 'cr-modal-talla__op';
        li.textContent = op.value;
        var agotada = op.classList.contains('disabled') || op.disabled;
        if (agotada) { li.classList.add('is-agotada'); li.title = 'Agotada'; }
        if (op.checked) { li.classList.add('is-activa'); li.setAttribute('aria-selected', 'true'); }
        li.addEventListener('click', function () {
          if (agotada) return;
          op.click();
          cerrarLista();
          setTimeout(sync, 400);
        });
        lista.appendChild(li);
      });
    }
    function sync() {
      var m = main();
      var ops = opcionesTalla();
      var t = tallaElegida();
      var agotado = !m || m.disabled || m.getAttribute('aria-disabled') === 'true';
      cajaTalla.hidden = ops.length < 2;
      txtTalla.textContent = t ? 'Talla ' + t : 'Elige talla';
      btnCompra.textContent = agotado && t ? 'Agotado' : 'Añadir al carrito';
      btnCompra.disabled = agotado && !!t;
      pintarLista();
      var varias = items().length > 1;
      btnPrev.hidden = !varias;
      btnNext.hidden = !varias;
    }

    btnTalla.addEventListener('click', function (e) {
      e.stopPropagation();
      var abrir = lista.hidden;
      lista.hidden = !abrir;
      btnTalla.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      if (abrir) {
        var act = lista.querySelector('.is-activa');
        if (act) lista.scrollTop = act.offsetTop - lista.clientHeight / 2 + act.clientHeight / 2;
      }
    });
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('[data-cr-modal-talla-caja]')) cerrarLista();
    });

    // El tema cierra la ampliación al soltar el ratón fuera de la foto: no debe pasar con nuestros controles
    [btnPrev, btnNext, modal.querySelector('.cr-modal-compra')].forEach(function (el) {
      el.addEventListener('pointerup', function (e) { e.stopPropagation(); });
    });
    btnPrev.addEventListener('click', function () { ir(-1); });
    btnNext.addEventListener('click', function () { ir(1); });
    btnCompra.addEventListener('click', function () {
      var m = main();
      if (!m || btnCompra.disabled) return;
      if (!cajaTalla.hidden && !tallaElegida()) { btnTalla.click(); return; }
      if (cerrar) cerrar.click();
      setTimeout(function () { m.click(); }, 150);
    });
    document.addEventListener('keydown', function (e) {
      if (!modal.hasAttribute('open')) return;
      if (e.key === 'Escape') cerrarLista();
      if (e.key === 'ArrowLeft') ir(-1);
      if (e.key === 'ArrowRight') ir(1);
    });
    new MutationObserver(function () { if (modal.hasAttribute('open')) { recordar(); sync(); } }).observe(modal, { attributes: true, attributeFilter: ['open'] });

    recordar();
    sync();
  }

  function preparar(modal) {
    if (modal.hasAttribute('open')) { iniciar(modal); return; }
    var obs = new MutationObserver(function () {
      if (!modal.hasAttribute('open')) return;
      obs.disconnect();
      iniciar(modal);
    });
    obs.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  function arrancar() {
    [].slice.call(document.querySelectorAll('product-modal[id^="ProductModal-"]')).forEach(preparar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
